/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { omit } from 'lodash';
import { SearchInput } from '@waca/ca-ui-toolkit';

export default class FilterSearchInput extends Component<any, any> {
	static propTypes = {
		delay: PropTypes.number,
		onChange: PropTypes.func.isRequired,
	};

	static defaultProps = {
		delay: 800,
	};

	_onSearchTimeout: number;

	_onChange = searchString => {
		const { delay, onChange } = this.props;

		if (this._onSearchTimeout) {
			clearTimeout(this._onSearchTimeout);
		}
		this._onSearchTimeout = window.setTimeout(() => {
			onChange && onChange(searchString);
		}, delay);
	};

	render() {
		const passThroughProps = {
			...omit(this.props, 'delay', 'onChange'),
		};

		return <SearchInput {...passThroughProps} onChange={this._onChange} />;
	}
}
